import { TECHNICIAN_RESTRICTED_ROUTES } from 'common/PrivateOutlet';
import { useGetCompanyAndUserInfoQuery } from 'common/queries';
import useAuth from 'common/useAuth';
import { useMemo } from 'react';
import { Link as RRLInk } from 'react-router-dom';

interface LinkProps {
  pathname: string;
  label: string;
  disableNavigate?: boolean;
}

const Link = ({ label, pathname, disableNavigate }: LinkProps) => {
  const { user } = useAuth();
  const company = useGetCompanyAndUserInfoQuery().data?.company;

  const canUserNavigate = useMemo(() => {
    const isManager = user?.isManager || false;
    const isReadonly = user?.isReadonly || false;
    const isAdmin = user?.isAdmin || false;

    // Disable navigation to Customers and Service Objects for technicians if the company has restrictTechnicianDataVisibility enabled
    if (
      !isAdmin &&
      !isManager &&
      !isReadonly &&
      company?.restrictTechnicianDataVisibility &&
      TECHNICIAN_RESTRICTED_ROUTES.some((route) => pathname.startsWith(route))
    ) {
      return false;
    }

    return true;
  }, [company?.restrictTechnicianDataVisibility, pathname, user]);

  if (disableNavigate || !canUserNavigate) {
    return label;
  }

  return (
    <RRLInk
      to={{
        pathname
      }}
    >
      {label}
    </RRLInk>
  );
};

export default Link;
